import { UserSchema } from "@/schemas/user.schema"

import { z } from "zod"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table"


interface Props {
    users: z.infer<typeof UserSchema>[]
}


import { Dialog, DialogTrigger, DialogContent, DialogTitle } from "@/components/ui/dialog";
import ChangePasswordForm from "@/components/ChangePasswordForm";
import { Button } from "@/components/ui/button";
import { useState } from "react";

function ChangePasswordAction({ user }: { user: z.infer<typeof UserSchema> }) {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">Change Password</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogTitle>Change Password for {user.U_Email}</DialogTitle>
        <ChangePasswordForm email={user.U_Email} onSuccess={() => setOpen(false)} onClose={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}

export default function UsersTable(props: Props) {
    return <Table>
        <TableHeader>
            <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Actions</TableHead>
            </TableRow>
        </TableHeader>
        <TableBody>
            {props.users?.map((user) => (
                <TableRow key={user.U_ID}>
                    <TableCell>{user.U_Firstname} {user.U_Lastname}</TableCell>
                    <TableCell>{user.U_Email}</TableCell>
                    <TableCell>
                        <ChangePasswordAction user={user} />
                    </TableCell>
                </TableRow>
            ))}
        </TableBody>
    </Table>
}